import script from "./register_spar.vue?vue&type=script&setup=true&lang=js"
export * from "./register_spar.vue?vue&type=script&setup=true&lang=js"

import "./register_spar.vue?vue&type=style&index=0&id=22b0d5d6&lang=scss"
import "./register_spar.vue?vue&type=style&index=1&id=22b0d5d6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b0d5d6"]])

export default __exports__